module.exports = __webpack_public_path__ + "img/DE01957.78364bcf.png";